/**
 * 折りたたみコンテンツのアコーディオン開閉アニメーション
 *
 * <details> 要素のネイティブ開閉はアニメーション不可のため、
 * JSで height トランジションを制御して滑らかに展開・収縮させる。
 */
(function () {
  var accordionDetails = document.querySelectorAll('.collapsible-content .accordion details');

  accordionDetails.forEach(function (details) {
    var summaryElement = details.querySelector('summary');
    var contentWrapper = details.querySelector('.accordion__content-wrapper');
    if (!summaryElement || !contentWrapper) return;

    summaryElement.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.open) {
        // 閉じる: 現在の高さを明示的にセットしてから 0 へトランジション
        contentWrapper.style.height = contentWrapper.scrollHeight + 'px';
        requestAnimationFrame(function () {
          contentWrapper.style.height = '0px';
        });
        contentWrapper.addEventListener('transitionend', function onCloseEnd() {
          details.removeAttribute('open');
          contentWrapper.style.height = '';
          contentWrapper.removeEventListener('transitionend', onCloseEnd);
        });
      } else {
        // 開く: open属性を付与後、0 からコンテンツ高さへトランジション
        details.setAttribute('open', '');
        var expandedHeight = contentWrapper.scrollHeight;
        contentWrapper.style.height = '0px';
        requestAnimationFrame(function () {
          contentWrapper.style.height = expandedHeight + 'px';
        });
        contentWrapper.addEventListener('transitionend', function onOpenEnd() {
          contentWrapper.style.height = '';
          contentWrapper.removeEventListener('transitionend', onOpenEnd);
        });
      }
    });
  });
})();
